import React, { useState } from 'react';
import ImageSlider from './ImageSlider';
import '../assets/css/TrackNow.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Helmet } from "react-helmet-async";

const API_BASE_URL = process.env.REACT_APP_API_URL;

const TrackNow = () => {
  const [orderId, setOrderId] = useState('');
  const [orderStatus, setOrderStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  const handleTrackOrder = async () => {
    if (!orderId.trim()) {
      setErrorMessage('Please enter an order ID.');
      return;
    }

    try {
      const response = await axios.get(`${API_BASE_URL}/campaign/${orderId}/track-order`);

      if (response.data && response.data.order) {
        setOrderStatus(response.data.order);
        setErrorMessage('');
      } else {
        setOrderStatus(null);
        setErrorMessage('Order not found.');
      }
    } catch (error) {
      setOrderStatus(null);
      setErrorMessage('Something went wrong. Please try again.');

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error?.response?.data?.message || 'Something went wrong. Please try again.',
      });
    }
  };

  return (
      <>
      <Helmet>
        <title>Order Tracking – Farmer Boaz</title>
        <meta name="description" content="Track the status of your Farmer Boaz order with your order ID." />
      </Helmet>
    <div className="track-now-container">
      <div className="image-slider-container">
        <ImageSlider />
      </div>

      <div className="track-now-header">
        <h2>Track Your Order</h2>
        <p>Enter your order ID to track its status.</p>
      </div>
      <div className="track-form-card">
      <div className="track-input-container">
        <input
          type="text"
          placeholder="Enter Order ID"
          value={orderId}
          onChange={(e) => setOrderId(e.target.value)}
          className="track-input"
        />
        <button onClick={handleTrackOrder} className="track-button">
          Track Now
        </button>
      </div>
      </div>

      {errorMessage && <p className="error-message">{errorMessage}</p>}

      {orderStatus?.timeline?.length > 0 && (
        <div className="order-status-container">
          <h3>Order Status: {orderStatus.status}</h3>
          <div className="order-timeline">
            {orderStatus.timeline.map((item, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-circle"></div>
                <div className="timeline-stage">
                  <p>
                    <strong>{item.stage}</strong> -{' '}
                    {new Date(item.date).toLocaleDateString()}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {orderStatus?.cartDetails?.length > 0 && (
        <div className="cart-details-section">
          <h3>Order Items</h3>
          <table className="cart-details-table">
            <thead>
              <tr>
                <th>Product</th>
                <th>Size</th>
                <th>Quantity</th>
                <th>Unit Price (CAD)</th>
                <th>Total Price (CAD)</th>
              </tr>
            </thead>
            <tbody>
              {orderStatus.cartDetails.map((item, index) => (
                <tr key={index}>
                  <td data-label="Product">{item.productType}</td>
                  <td data-label="Size">{item.size}</td>
                  <td data-label="Quantity">{item.quantity}</td>
                  <td data-label="Unit Price">${item.unitPrice}</td>
                  <td data-label="Total">${(item.unitPrice * item.quantity).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <h4 className="cart-total">Grand Total: ${orderStatus.total}</h4>
        </div>
      )}
    </div>
    </>
  );
};

export default TrackNow;
